import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import appGoogleTracking from '../../../modules/googletracking';
import GLOBAL_CONFIG from '../../../config/config';
import { NavLink } from "react-router-dom";


/* 
    Title content on all pages - to display the first part of all pages
    This gives uniformity in all pages in terms of CSS and HTML codes
*/

const TitleContent = (props) => {
    
    
    let RenderHeading = (props.heading !== undefined && props.heading !== null) ? <h1>{props.heading}</h1> : null;

    let RenderSubheading = (props.subheading !== undefined && props.subheading !== null) ? <h2 style={{ maxWidth:'31em'}}>{props.subheading}</h2> : null;

    let RenderParaText = (props.paragraph !== undefined && props.paragraph !== null) ? <p className='link'>{props.paragraph}</p> : null;

    let RenderSubheading2 = (props.subheading2 !== undefined && props.subheading2 !== null) ? <h2>{props.subheading2}</h2> : null;

    return (
        <div className="s-content-title">
            {RenderHeading}
            {RenderSubheading}
            {RenderParaText}
            {RenderSubheading2}
            {/* {
                (props.promotionCampaign === "budni" && props.url === '/') ?
                    <NavLink
                        to={GLOBAL_CONFIG.Route.participation}
                        exact
                        data-event="join_now"
                        data-category="Start Page"
                        data-action="Click on Join Now"
                        data-label="EASTER_SP_PART"
                        onClick={appGoogleTracking.processEventCTANavLink}
                    ><div class="btn__container btn--primary "><span class="btn__text">JETZT MITMACHEN</span></div></NavLink>
                :null
            } */}
            
        </div>
    );
}

export default TitleContent;
